import moment from 'moment'

export default function(dateString, customFormat) {
    if (dateString) {
        return moment(String(dateString)).format(customFormat ?? 'DD MMM YYYY')
    }
}